/* eslint-disable
    no-console,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class GoogleApiService {
   $log: any
   $q: any
   $timeout: any
   authService: any
   fire: any
   i18n: any
   savedSearchConfigs: any
   scope: any
   retryLogin: boolean
   writeChain: any
   maxWriteRetries: number
   writeRetryBackoffMs: number
   constructor(configs: any, store: any, i18n: any, hooksService: any, $q: any, $log: any, authService: any, $timeout: any) {
      this.init = this.init.bind(this)
      this.initDriveCode = this.initDriveCode.bind(this)
      this.loginSuccessHandler = this.loginSuccessHandler.bind(this)
      this.logoutSuccessHandler = this.logoutSuccessHandler.bind(this)
      this.getFileId = this.getFileId.bind(this)
      this.getFileContents = this.getFileContents.bind(this)
      this.writeToFile = this.writeToFile.bind(this)
      this.putFileContents = this.putFileContents.bind(this)
      this.isConflictError = this.isConflictError.bind(this)
      this.createFileAndReturnId = this.createFileAndReturnId.bind(this)
      this.handleApiError = this.handleApiError.bind(this)
      this.i18n = i18n
      this.$q = $q
      this.$log = $log
      this.authService = authService
      this.$timeout = $timeout
      this.savedSearchConfigs = configs.data.savedSearchAndItems
      this.retryLogin = false
      // Writes are queued through this promise chain so only one full-file write is ever
      // in flight at a time (see writeToFile). A failed write does not break the queue.
      this.writeChain = this.$q.resolve()
      this.maxWriteRetries = 3
      this.writeRetryBackoffMs = 300
      this.scope = {
         name: 'Google',
         userId: '',
         userDisplay: '',
         provider: 'google',
         initialized: false,
         accessToken: null //TODO - check if this is updated correctly after a auth provider refresh - probably not
      }

      hooksService.setHooks(this, 'GoogleApiService', ['initSuccess', 'initFailed', 'signOut'])
   }

   init() {
      if (!this.savedSearchConfigs.providers.includes('google')) {
         return
      }
      if (!this.authService.providerSupportsFeature('google', 'cloudStorage')) { 
         return 
      }
      return this.scope.providerDisplayName = this.scope.name
   }

   initDriveCode() {
      const deferred = this.$q.defer()
      // load the google 'drive' api
      this.$timeout(() => { 
         // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
         return gapi.client.load('https://www.googleapis.com/discovery/v1/apis/drive/v3/rest')
            .then(() => {
               // store token and scope value
               // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
               gapi.client.setToken({access_token: this.scope.accessToken})
               this.scope.initialized = true
               deferred.resolve()
               return this.fire('initSuccess')
            }).catch((err: any) => {
               console.log(err)
               this.scope.initialized = false
               // TODO handle errors here better, display something to the user
               this.fire('initFailed')
               return deferred.reject(err)
            })
      }
      ,
      500)

      return deferred.promise
   }

   loginSuccessHandler(event: any, args: any) {
      if (!this.savedSearchConfigs.providers.includes('google')) {
         return
      }
      if (!this.authService.providerSupportsFeature(args.provider, 'cloudStorage') || (args.provider !== this.scope.provider)) {
         return
      }

      this.scope.userId = this.authService.scope.auth[this.scope.provider].user
      this.scope.accessToken = this.authService.scope.auth[this.scope.provider].accessToken
      this.scope.userDisplay = this.authService.scope.auth[this.scope.provider].username

      if (this.scope.userId && this.scope.accessToken) {
         this.initDriveCode()
      } else {
         this.$log.error('No userId or accessToken, cannot initialize google API')
         this.scope.initialized = false
         return this.fire('initFailed')
      }
   }

   logoutSuccessHandler(event: any, args: any) {
      if (args.provider !== this.scope.provider) {
         return
      }

      // remove save searches from session etc
      this.scope.userId = ''
      this.scope.userDisplay = ''
      this.scope.searches = []

      if(this.retryLogin) {
         this.retryLogin = false
         const feature = "cloudStorage"
         const provider = "google"
         this.authService.openRetryDialog(feature, provider)
      }
      return this.fire('signOut')
   }

   // returns a promise
   getFileId(filename: any) {
      const deferred = this.$q.defer()
      const handleFileList = (response: any) => {
         const {
            files
         } = response.result
         // This user has already signed in with Google on Summon before and has our appfile saved
         if (files.length === 1) {
            // return file metadata in the same JSON structure that the API response does.
            // handles the case of an existing file and the creation of a new one -- see below
            return deferred.resolve(files[0].id)
         } else {
            // If there is no app file already, it's the first time the user signed in with
            // google on Summon. Create the file now with empty data so we can start adding searches
            return this.createFileAndReturnId(filename)
         }
      }

      // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
      gapi.client.drive.files.list({q: `name='${filename}'`, spaces: 'appDataFolder'}).then(handleFileList).catch((err: any) => deferred.reject(this.handleApiError(err)))
      return deferred.promise
   }

   getFileContents(fileId: any) {
      const deferred = this.$q.defer()
      // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
      gapi.client.drive.files.get({fileId, alt: 'media'})
         .then((resp: any) => {
            return deferred.resolve(resp.result)
         }).catch((err: any) => {
            return deferred.reject(this.handleApiError(err))
         })
      return deferred.promise
   }

   // writes data to the user's Google drive app file - will overwrite the entire file's contents
   // Writes are serialized (one in flight at a time) so overlapping rapid saves/deletes cannot
   // race and drop a write; a concurrent-modification conflict (from another tab/device) is
   // retried a bounded number of times, since a full-file overwrite is idempotent for the UI.
   writeToFile(data: any, fileId: any) {
      this.writeChain = this.writeChain
         .catch(() => {}) // a previously failed write must not break the queue
         .then(() => this.putFileContents(data, fileId, 0))
      return this.writeChain
   }

   putFileContents(data: any, fileId: any, attempt: number): any {
      const boundary = '-------314159265358979323846'
      const delimiter = '\u000d\n--' + boundary + '\u000d\n'
      const closeDelim = '\u000d\n--' + boundary + '--'
      const contentType = 'text/json'
      const metadata = {mimeType: contentType}
      const multipartRequestBody = delimiter + 'Content-Type: application/json\u000d\n\u000d\n' + JSON.stringify(metadata) + delimiter + 'Content-Type: ' + contentType + '\u000d\n' + '\u000d\n' + JSON.stringify(data) + closeDelim
      const header = {'Content-Type': `multipart/mixed; boundary='${boundary}'`}

      const deferred = this.$q.defer()

      // need to use the /upload path for multipart uploads -- JS api doesn't support this
      const requestParams = {
         path: '/upload/drive/v3/files/appDataFolder',
         method: 'PATCH',
         params: {
            fileId,
            uploadType: 'multipart'
         },
         headers: {
            'Content-Type': `multipart/mixed; boundary='${boundary}'`
         },
         body: multipartRequestBody
      }

      // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
      gapi.client.request(requestParams).then((resp: any) => deferred.resolve(resp)).catch((err: any) => {
         if (this.isConflictError(err) && attempt < this.maxWriteRetries) {
            // The file changed under us (a concurrent write). Wait (exponential backoff) and retry.
            this.$timeout(() => {
               this.putFileContents(data, fileId, attempt + 1).then(deferred.resolve, deferred.reject)
            }, this.writeRetryBackoffMs * Math.pow(2, attempt))
         } else {
            // handleApiError returns a rejected promise; forward its Error reason into the
            // deferred (rejecting with the promise itself would surface a promise object to
            // callers instead of the underlying Error).
            this.handleApiError(err).catch((error: any) => deferred.reject(error))
         }
      })
      return deferred.promise
   }

   // A concurrent-modification conflict from Google Drive: HTTP 409/412, or a precondition
   // reason of `conditionNotMet` in the structured error body.
   isConflictError(err: any) {
      const status = err?.status ?? err?.result?.error?.code
      const reason = err?.result?.error?.errors?.[0]?.reason
      return status === 409 || status === 412 || reason === 'conditionNotMet'
   }

   // creates the default Summon's app file to the user's Google drive account; returns a promise with fileId
   createFileAndReturnId(filename: any) {
      const deferred = this.$q.defer()
      const fileMetadata = {
         name: filename,
         mimeType: 'application/json',
         parents: ['appDataFolder']
      }

      // @ts-expect-error TS(2304) FIXME: Cannot find name 'gapi'.
      gapi.client.drive.files.create({resource: fileMetadata}).then((resp: any) => deferred.resolve(resp.id)).catch((err: any) => deferred.reject(this.handleApiError(err)))
      return deferred.promise
   }

   // handle API-specific error, and create nice error with a readable string
   handleApiError(response: any) {
      // handle specific errors as necessary
      const error = new Error()
      error.name = "googleApiService"

      switch (response.status) {
         case 403:
            const feature = "cloudStorage"
            const provider = "google"
            const redirectUrl = null
            const summonOnly = false
            const showToast = false // don't show toast, instead a modal will open with choices
            this.authService.logout(feature, provider, redirectUrl, summonOnly, showToast)
            this.retryLogin = true
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_ERROR
            break
         case 401:
            error.message = this.i18n.translations.CLOUD_STORAGE_AUTH_ERROR
            break
         case 500:
            error.message = this.i18n.translations.CLOUD_STORAGE_API_ERROR
            break
      }

      if (response.result) {
         error.message += ": " + response.result.error.message
      }

      this.$log.error('Google API Error', response)
      return this.$q.reject(error)
   }
}

GoogleApiService.$inject = ['configService', 'storeService', 'translationService', 'hooksService', '$q', '$log', 'authenticationService','$timeout']

angular.module('summonApp.services')
   .service('googleApiService', GoogleApiService)
